import styled from 'styled-components';
import { customPalette } from '../../theme';
import DefaultGrid from '../grid/DefaultGrid';

export const DisplayOnActiveRowClassName = 'displayOnActiveRow';
export const AlwaysDisplayClassName = 'alwaysVisible';

/** Filter_applied icon from entity management (24x24 navy on transparent), inlined so CSS url() always resolves. */
const FILTERED_COLUMN_ICON_DATA_URI =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACY0lEQVR4AaxVS2gTURQ9d0QtWnGnOxfiThRsq2AmunIrIhgEmxS6cScoqKBCiW79dK0iRdOEFuNOXJeaCcWatQv3ikVwYcEUnbmem4TJZPKblgzv5N137n3nzHszb+LAzU3BzS4TfjemA3JJoKyLIbcEajsAbhO/4eh5SHCmE3qa4ySYYl0bjqYB3STu0ECvUnwBH4seKqXaSGBaji7wxq/QgJ1qnb+jbS3NpsFopTvUBhtkMrv4oO4hnc0nRio7G3UYbPBj91E+qDlOOE4Mb6ouBE+jhWagUaIjXi19pcErKCbwZ2selcV8X/j6DhCX9bcQXipmEA57BvX9NmEDY3vKzAvR3SYzB+HIeybewCu+Zt9qguEGtRd/oXIJkJN8Hnl0X9IwV/xEfd+NeHq4gc2oFja4dJrofaRnLhgVws3R1JmA/LsIu5kw0QySGVitV1wD5C40KHMlR2BXw0wfQP3L8Ja+GRVHcgOb6RXmuZIV4rENgeAZ+zlUS6vse7btGZiEOJ/ZjROA4jACqTXiPj9tgxQPUyr7HL3BfW4pqNqbZDDCgRO0NYyJoZ2s8h0HvvOgXO+Acc1cbGqyIQ0i58yEFA/DqRYbFxIMVLa4NcdwduYURz5EIgJkYo0GsQITNGGDxbEJcPyXpD5wa9bZH4Ifm08y0vqcZBM2RCrDsFL6heriTQqfgOAR9ta9MNcj4Ap6sEmotcKXxndp5e3moPKdGwxSjeSaBiJjEW40YUvTDMo8LLM4N+0ifW1yJDCtQPjHI8s0EB57GadJBcpT2ol1ckMglv/EujYCsU/HAW7Fk/8AAAD///Lw+z4AAAAGSURBVAMACzRW+4SPcGUAAAAASUVORK5CYII=';

export const StyledTable = styled(DefaultGrid)`
    .e-headercell {
        background-color: ${customPalette.blueGreyNeutralTint2} !important;
        font-weight: bold;
        font-size: var(--header-font-size);
        border: none;
    }

    .e-columnheader {
        height: 36px !important;
    }

    .e-headertext {
        font-size: var(--header-font-size);
        color: ${customPalette.blueDark};
        font-weight: 600;
        text-align: center;
    }

    th.e-headercell[aria-sort='ascending'] .e-headertext,
    th.e-headercell[aria-sort='descending'] .e-headertext,
    th.e-headercell[aria-sort='ascending'] .e-sortfilterdiv,
    th.e-headercell[aria-sort='descending'] .e-sortfilterdiv {
        color: ${customPalette.themePrimary};
    }

    .e-icon-ascending::before {
        content: '\\e776';
    }

    .e-icon-descending::before {
        content: '\\e729';
    }

    /* Reset Grid: Syncfusion's icon font has no reset-style glyph to match Fluent's Arrow Reset icon, so
       this masks it in instead -- keyed to the "e-reset" class Syncfusion gives the icon span from this
       button's own prefixIcon ('e-icons e-reset' in ReportsTable.tsx), same class-based convention as the
       sort icons above. */
    .e-reset::before {
        content: '' !important;
        display: inline-block;
        width: 1em;
        height: 1em;
        background-color: currentColor;
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M5.85355 2.64645C6.04882 2.84171 6.04882 3.15829 5.85355 3.35355L4.20711 5H11C14.3137 5 17 7.68629 17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 10.7239 5.22386 10.5 5.5 10.5C5.77614 10.5 6 10.7239 6 11C6 13.7614 8.23858 16 11 16C13.7614 16 16 13.7614 16 11C16 8.23858 13.7614 6 11 6H4.20711L5.85355 7.64645C6.04882 7.84171 6.04882 8.15829 5.85355 8.35355C5.65829 8.54882 5.34171 8.54882 5.14645 8.35355L2.64645 5.85355C2.45118 5.65829 2.45118 5.34171 2.64645 5.14645L5.14645 2.64645C5.34171 2.45118 5.65829 2.45118 5.85355 2.64645Z' fill='black'/%3E%3C/svg%3E");
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M5.85355 2.64645C6.04882 2.84171 6.04882 3.15829 5.85355 3.35355L4.20711 5H11C14.3137 5 17 7.68629 17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 10.7239 5.22386 10.5 5.5 10.5C5.77614 10.5 6 10.7239 6 11C6 13.7614 8.23858 16 11 16C13.7614 16 16 13.7614 16 11C16 8.23858 13.7614 6 11 6H4.20711L5.85355 7.64645C6.04882 7.84171 6.04882 8.15829 5.85355 8.35355C5.65829 8.54882 5.34171 8.54882 5.14645 8.35355L2.64645 5.85355C2.45118 5.65829 2.45118 5.34171 2.64645 5.14645L5.14645 2.64645C5.34171 2.45118 5.65829 2.45118 5.85355 2.64645Z' fill='black'/%3E%3C/svg%3E");
        -webkit-mask-size: contain;
        mask-size: contain;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-position: center;
        mask-position: center;
    }

    /* Clear Filters: Syncfusion's e-close glyph is taller than Fluent's Dismiss20 inside the medium Button
       icon slot (20px), so mask Dismiss20Regular in instead -- keyed to the "e-close" class from this
       button's prefixIcon ('e-icons e-close' in ReportsTable.tsx), same convention as .e-reset above.
       Scoped to the toolbar button so other Syncfusion close icons (dialogs, etc.) are left alone. */
    .e-toolbar .e-toolbar-item .e-tbar-btn .e-close::before {
        content: '' !important;
        display: inline-block;
        width: 1em;
        height: 1em;
        background-color: currentColor;
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z' fill='black'/%3E%3C/svg%3E");
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z' fill='black'/%3E%3C/svg%3E");
        -webkit-mask-size: contain;
        mask-size: contain;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-position: center;
        mask-position: center;
    }

    /* Fluent appearance="subtle" for every non-primary toolbar action (Edit/Bulk edit, Cancel,
       Column Chooser, Clear Filters, Reset Grid). Transparent rest state + NeutralForeground2, then
       Fluent's subtle hover/pressed tokens -- overrides the shared outline chrome on .e-tbar-btn below.
       Column Chooser selector is deepened to .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn so it
       beats that later border-shorthand !important (a shallower earlier border-color loses). Ids must
       match BULK_EDIT_* / CLEAR_FILTERS / RESET_GRID toolbar item ids in ReportsTable.tsx. Save is
       primary (with Add New) further below. */
    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn,
    #bulkEditReturns,
    #bulkEditCancel,
    #clearFilters,
    #resetGrid {
        background-color: var(--colorTransparentBackground) !important;
        border-color: transparent !important;
        color: var(--colorNeutralForeground2) !important;
    }

    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn .e-tbar-btn-text,
    #bulkEditReturns .e-btn-icon,
    #bulkEditReturns .e-tbar-btn-text,
    #bulkEditCancel .e-btn-icon,
    #bulkEditCancel .e-tbar-btn-text,
    #clearFilters .e-btn-icon,
    #clearFilters .e-tbar-btn-text,
    #resetGrid .e-btn-icon,
    #resetGrid .e-tbar-btn-text {
        color: inherit !important;
    }

    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn:hover,
    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn:focus:not(:focus-visible),
    #bulkEditReturns:hover,
    #bulkEditReturns:focus:not(:focus-visible),
    #bulkEditCancel:hover,
    #bulkEditCancel:focus:not(:focus-visible),
    #clearFilters:hover,
    #clearFilters:focus:not(:focus-visible),
    #resetGrid:hover,
    #resetGrid:focus:not(:focus-visible) {
        background-color: var(--colorSubtleBackgroundHover) !important;
        border-color: transparent !important;
        color: var(--colorNeutralForeground2Hover) !important;
    }

    /* Keyboard focus: keep subtle surface, but paint Fluent's focus ring (transparent border would hide it). */
    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn:focus-visible,
    #bulkEditReturns:focus-visible,
    #bulkEditCancel:focus-visible,
    #clearFilters:focus-visible,
    #resetGrid:focus-visible {
        background-color: var(--colorSubtleBackgroundHover) !important;
        border-color: var(--colorStrokeFocus2) !important;
        color: var(--colorNeutralForeground2Hover) !important;
        outline: var(--strokeWidthThick) solid var(--colorTransparentStroke) !important;
        box-shadow: 0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset !important;
        z-index: 1;
    }

    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn:hover:active,
    #bulkEditReturns:hover:active,
    #bulkEditCancel:hover:active,
    #clearFilters:hover:active,
    #resetGrid:hover:active {
        background-color: var(--colorSubtleBackgroundPressed) !important;
        border-color: transparent !important;
        color: var(--colorNeutralForeground2Pressed) !important;
    }

    /* Fluent subtle disabled: keep the transparent surface; only mute the foreground. Without this the
       shared .e-tbar-btn[aria-disabled] filled-disabled chrome would show through on Edit (often disabled
       until a row is selected). */
    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn[aria-disabled='true'],
    #bulkEditReturns[aria-disabled='true'],
    #bulkEditCancel[aria-disabled='true'],
    #clearFilters[aria-disabled='true'],
    #resetGrid[aria-disabled='true'] {
        background-color: var(--colorTransparentBackground) !important;
        border-color: transparent !important;
        color: var(--colorNeutralForegroundDisabled) !important;
    }

    /* Figma has no icon on the Columns button -- just the label and a trailing chevron, the same way a
       Fluent MenuButton signals it opens a menu. Syncfusion registers Column Chooser with its own icon
       (masked in via .e-columnchooser-btn previously); hide that and grow a chevron in its place instead of
       reworking this into a fully custom toolbar item. */
    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn {
        /* Matches Fluent MenuButton's menuIcon margin (spacingHorizontalXS), not a 20px iconAfter gap. */
        gap: var(--spacingHorizontalXS);
    }

    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn .e-btn-icon {
        display: none !important;
    }

    /* Fluent MenuButton's menuIcon slot is 12px for medium (ChevronDownRegular scaled), not a 20px
       iconAfter -- mask ChevronDown12Regular at that size so this reads as a MenuButton chevron. */
    &.e-grid .e-toolbar .e-toolbar-item.e-cc-toolbar .e-tbar-btn::after {
        content: '';
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: currentColor;
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath d='M2.15 4.65c.2-.2.5-.2.7 0L6 7.79l3.15-3.14a.5.5 0 1 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 0-.7Z' fill='black'/%3E%3C/svg%3E");
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath d='M2.15 4.65c.2-.2.5-.2.7 0L6 7.79l3.15-3.14a.5.5 0 1 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 0-.7Z' fill='black'/%3E%3C/svg%3E");
        -webkit-mask-size: contain;
        mask-size: contain;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-position: center;
        mask-position: center;
    }

    /* Filter icon button: Fluent Button appearance="transparent" size="small" iconOnly
       (24x24, 1px padding, NeutralForeground2). See
       https://storybooks.fluentui.dev/react/?path=/docs/components-button-button--docs
       Syncfusion's theme also applies a transform on :active -- neutralized here the same way
       toolbar buttons pin transform: none. Keep line-height in sync with font-size so the e-icons
       glyph (::before) is not collapsed to zero height. */
    &.e-grid .e-filtermenudiv {
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        min-width: 24px;
        max-width: 24px;
        padding: 1px;
        border: var(--strokeWidthThin) solid transparent;
        border-radius: var(--borderRadiusMedium);
        background-color: var(--colorTransparentBackground);
        color: var(--colorNeutralForeground2);
        font-size: 20px;
        line-height: 20px;
        cursor: pointer;
        transition-duration: var(--durationFaster);
        transition-property: background, border, color;
        transition-timing-function: var(--curveEasyEase);
    }

    &.e-grid .e-filtermenudiv:hover,
    &.e-grid .e-filtermenudiv:active {
        transform: none !important;
    }

    &.e-grid .e-filtermenudiv:hover {
        background-color: var(--colorTransparentBackgroundHover);
        color: var(--colorNeutralForeground2Hover);
    }

    &.e-grid .e-filtermenudiv:active {
        background-color: var(--colorTransparentBackgroundPressed);
        color: var(--colorNeutralForeground2Pressed);
    }

    /* Stays visually pressed while its own menu is open, same as the Column Chooser trigger further down
       (:has(.e-ccdlg.e-popup-open)) -- otherwise the button reads as idle while its dialog is on screen. */
    &.e-grid .e-filtermenudiv.e-filter-menu-open {
        background-color: var(--colorTransparentBackgroundPressed);
        color: var(--colorNeutralForeground2Pressed);
    }

    &.e-grid .e-filtermenudiv:focus-visible {
        border-color: var(--colorStrokeFocus2);
        outline: var(--strokeWidthThick) solid var(--colorTransparentStroke);
        box-shadow: 0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;
        z-index: 1;
    }

    /* Filter icon "Selected": a solid funnel while the filter's own menu is open, in the brand primary
       color rather than the neutral text color -- matches Figma's "Filled" filter icon state. Syncfusion's
       icon font has no filled funnel glyph of its own, so this masks in Fluent's solid funnel path instead,
       same mask-image technique as the Column Chooser icon above. "e-filter-menu-open" is applied/removed
       by the MutationObserver in ReportsTable.tsx as the dialog opens/closes, since Syncfusion has no class
       or event of its own for that state. */
    &.e-grid .e-filtermenudiv.e-filter-menu-open::before {
        content: '' !important;
        display: inline-block;
        width: 1em;
        height: 1em;
        background-color: ${customPalette.themePrimary};
        /* Fluent's own funnel-shaped Filter icon: its path only actually spans roughly [4,20]x[5,19] within
           the 24x24 canvas Figma exports it in -- stretching that whole canvas to 100% (as this used to)
           stretches the built-in padding along with it, rendering visibly smaller than the outline icon it
           replaces. viewBox is cropped to the path's real, centered bounding box so the ink itself fills the
           box, matching the outline icon's footprint. */
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='4 4 16 16'%3E%3Cpath d='M4.12066 5.84294L10.1445 13.005C10.2345 13.1106 10.2846 13.2456 10.2855 13.3856V17.7359C10.285 17.7969 10.3033 17.8565 10.3378 17.9062C10.3724 17.9559 10.4215 17.9931 10.4781 18.0127L13.3408 18.985C13.3836 18.9996 13.4292 19.0036 13.4738 18.9967C13.5184 18.9897 13.5607 18.9719 13.5973 18.9449C13.6338 18.9179 13.6635 18.8824 13.6839 18.8413C13.7043 18.8002 13.7147 18.7547 13.7145 18.7087V13.3856C13.7159 13.2454 13.7666 13.1103 13.8573 13.005L19.8793 5.84294C19.9416 5.7689 19.9818 5.67819 19.9951 5.58155C20.0084 5.48492 19.9943 5.38641 19.9545 5.2977C19.9147 5.20899 19.8507 5.1338 19.7703 5.08104C19.6899 5.02828 19.5963 5.00015 19.5007 5H4.50105C4.4053 4.9998 4.3115 5.02768 4.23081 5.0803C4.15012 5.13293 4.08593 5.2081 4.04587 5.29687C4.00581 5.38565 3.99156 5.4843 4.00482 5.5811C4.01807 5.6779 4.05828 5.76878 4.12066 5.84294Z' fill='black'/%3E%3C/svg%3E");
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='4 4 16 16'%3E%3Cpath d='M4.12066 5.84294L10.1445 13.005C10.2345 13.1106 10.2846 13.2456 10.2855 13.3856V17.7359C10.285 17.7969 10.3033 17.8565 10.3378 17.9062C10.3724 17.9559 10.4215 17.9931 10.4781 18.0127L13.3408 18.985C13.3836 18.9996 13.4292 19.0036 13.4738 18.9967C13.5184 18.9897 13.5607 18.9719 13.5973 18.9449C13.6338 18.9179 13.6635 18.8824 13.6839 18.8413C13.7043 18.8002 13.7147 18.7547 13.7145 18.7087V13.3856C13.7159 13.2454 13.7666 13.1103 13.8573 13.005L19.8793 5.84294C19.9416 5.7689 19.9818 5.67819 19.9951 5.58155C20.0084 5.48492 19.9943 5.38641 19.9545 5.2977C19.9147 5.20899 19.8507 5.1338 19.7703 5.08104C19.6899 5.02828 19.5963 5.00015 19.5007 5H4.50105C4.4053 4.9998 4.3115 5.02768 4.23081 5.0803C4.15012 5.13293 4.08593 5.2081 4.04587 5.29687C4.00581 5.38565 3.99156 5.4843 4.00482 5.5811C4.01807 5.6779 4.05828 5.76878 4.12066 5.84294Z' fill='black'/%3E%3C/svg%3E");
        -webkit-mask-size: 100% 100%;
        mask-size: 100% 100%;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-position: center;
        mask-position: center;
    }

    /* Applied filter: Filter_applied asset from entity management (navy funnel+chevron in a rounded
       frame, transparent fill). Inlined data URI so url() always resolves. */
    &.e-grid .e-filtermenudiv.e-filtered:not(.e-filter-menu-open)::before {
        content: '' !important;
        display: inline-block;
        width: 1em;
        height: 1em;
        background-color: transparent !important;
        background-image: url(${FILTERED_COLUMN_ICON_DATA_URI});
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        -webkit-mask-image: none !important;
        mask-image: none !important;
    }

    /* Brand-colored, 6px-radius row-selection checkboxes -- scoped to the header (Select All) and row
       checkboxes only. Figma's own comment on the filter checkboxes calls out that Syncfusion's Fluent 2
       theme already renders those correctly out of the box; these selectors used to have no scope at all,
       so this same brand styling was overriding the Excel filter's checkbox list too. */
    &.e-grid .e-headercell .e-checkbox-wrapper.e-css,
    &.e-grid .e-rowcell .e-checkbox-wrapper.e-css {
        padding: unset;
    }

    &.e-grid .e-headercell .e-checkbox-wrapper .e-frame.e-icons,
    &.e-grid .e-rowcell .e-checkbox-wrapper .e-frame.e-icons {
        border-radius: 6px;
        border-color: ${customPalette.themePrimary};
    }

    &.e-grid .e-headercell .e-checkbox-wrapper .e-frame.e-icons.e-check,
    &.e-grid .e-rowcell .e-checkbox-wrapper .e-frame.e-icons.e-check {
        background-color: ${customPalette.themePrimary};
    }

    &.e-grid .e-headercell .e-checkbox-wrapper .e-frame.e-icons.e-stop,
    &.e-grid .e-rowcell .e-checkbox-wrapper .e-frame.e-icons.e-stop {
        color: ${customPalette.themePrimary};
    }

    /* Pointer cursor on the full checkbox cell; click → checkbox forwarding lives in ReportsTable
       (absolute-fill on .e-checkbox-wrapper collapses table-cell height and breaks header alignment). */
    &.e-grid .e-rowcell.e-gridchkbox,
    &.e-grid .e-headercell:has(.e-headerchkcelldiv) {
        cursor: pointer;
    }

    .e-gridheader .e-headercell .e-headercelldiv.e-headerchkcelldiv {
        margin-bottom: -5px;
    }

    &.e-grid.e-control .e-row .e-rowcell {
        background-color: #ffffff;
        color: ${customPalette.blueDark};
        font-size: 14px;
        border: none;
        font-weight: 600;
        border-bottom: 1px solid ${customPalette.statusCoolLightGrey};
        height: 100%;
    }

    &.e-grid.e-control .e-row .${AlwaysDisplayClassName} {
        display: inline-block;
    }

    &.e-grid.e-control .e-row:hover .${DisplayOnActiveRowClassName}, &.e-grid.e-control .e-row .e-focused .${DisplayOnActiveRowClassName} {
        display: inline-block;
    }

    .highlighted-search {
        background-color: ${customPalette.yellowDark};
    }

    /* Matches FilterBar's separator (border: none + this shadow) so the native toolbar reads as one
       continuous panel with the FilterBar row directly above it, instead of a jarring theme mismatch. */
    .e-toolbar {
        background-color: var(--colorNeutralBackground1) !important;
        border: none !important;
        box-shadow: 0px 1.6px 0px 0px #00000021;
        min-height: 40px !important;
        box-sizing: border-box;
    }

    /* Matches Fluent 9 medium Button metrics (FilterBar / @fluentui/react-button): 32px box from
       pad 5 + lineHeightBase300 + 1px stroke. Selector matches Syncfusion fluent's
       .e-toolbar .e-toolbar-item .e-tbar-btn (theme default min-height: 40px) so these win without
       relying on a shallower selector + unset. */
    .e-toolbar .e-toolbar-item .e-tbar-btn {
        align-items: center;
        box-sizing: border-box;
        display: inline-flex;
        justify-content: center;
        text-decoration-line: none;
        vertical-align: middle;
        margin: 0px;
        overflow: hidden;
        background-color: var(--colorNeutralBackground1) !important;
        color: var(--colorNeutralForeground1) !important;
        border: var(--strokeWidthThin) solid var(--colorNeutralStroke1) !important;
        font-family: var(--fontFamilyBase);
        outline-style: none;
        padding: 5px var(--spacingHorizontalM) !important;
        min-width: unset !important;
        height: 32px !important;
        min-height: 32px !important;
        border-radius: var(--borderRadiusMedium) !important;
        font-size: var(--fontSizeBase300) !important;
        font-weight: var(--fontWeightSemibold) !important;
        line-height: var(--lineHeightBase300) !important;
        transition-duration: var(--durationFaster);
        transition-property: background, border, color;
        transition-timing-function: var(--curveEasyEase);
    }

    /* Kill Syncfusion fluent's 18px toolbar icon metrics so the 32px button box isn't inflated and the
       glyph matches Fluent Button's 20px icon slot. */
    .e-toolbar .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon {
        width: 20px !important;
        height: 20px !important;
        min-width: 20px !important;
        font-size: 20px !important;
        line-height: 20px !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    .e-toolbar .e-toolbar-item .e-tbar-btn:hover,
    .e-toolbar .e-toolbar-item .e-tbar-btn:focus:not(:focus-visible) {
        background-color: var(--colorNeutralBackground1Hover) !important;
        border-color: var(--colorNeutralStroke1Hover) !important;
        padding: 5px var(--spacingHorizontalM) !important;
        box-shadow: none !important;
        transform: none !important;
    }

    /* Fluent Button [data-fui-focus-visible]: thick transparent outline + inset StrokeFocus2 ring.
       Syncfusion toolbar buttons have no Tabster focus attribute, so :focus-visible is the equivalent. */
    .e-toolbar .e-toolbar-item .e-tbar-btn:focus-visible {
        border-color: var(--colorStrokeFocus2) !important;
        border-width: var(--strokeWidthThin) !important;
        outline: var(--strokeWidthThick) solid var(--colorTransparentStroke) !important;
        box-shadow: 0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset !important;
        z-index: 1;
    }

    .e-toolbar .e-toolbar-item .e-tbar-btn:hover:active {
        background-color: var(--colorNeutralBackground1Pressed) !important;
        border-color: var(--colorNeutralStroke1Pressed) !important;
    }

    .e-toolbar .e-toolbar-item .e-tbar-btn[aria-disabled='true'] {
        background-color: var(--colorNeutralBackgroundDisabled) !important;
        color: var(--colorNeutralForegroundDisabled) !important;
        border-color: var(--colorNeutralStrokeDisabled) !important;
    }

    /* Syncfusion's fluent theme fills the disabled toolbar item's wrapping div with a grey background
       (.e-overlay); the button itself already shows its own disabled styling above, so this is redundant
       and clashes with the toolbar's background.
       Syncfusion also sets pointer-events: none on every .e-toolbar-item (and again on .e-overlay > *),
       which makes cursor: not-allowed unreachable -- hover falls through the item. Re-enable hit-testing
       on disabled items only so the not-allowed cursor paints; Toolbar.clickHandler already no-ops when
       the closest .e-toolbar-item has .e-overlay, so clicks stay inert. */
    .e-toolbar .e-toolbar-item.e-overlay {
        background-color: var(--colorNeutralBackground1) !important;
        pointer-events: auto !important;
        cursor: not-allowed !important;
    }

    /* Children inherit the wrapper's not-allowed cursor; keep them non-targets so hover/click land on
       the .e-overlay item (where clickHandler checks CLS_DISABLE). */
    .e-toolbar .e-toolbar-item.e-overlay > * {
        pointer-events: none !important;
        cursor: not-allowed !important;
    }

    /* Add New (default toolbar) and Save (bulk-edit toolbar) are the primary actions -- brand-filled
       on top of the shared base above. Every other toolbar button uses the subtle overrides further up.
       Ids must match ADD_NEW_RETURN_TOOLBAR_ITEM_ID / BULK_EDIT_SAVE_TOOLBAR_ITEM_ID in ReportsTable.tsx.
       Syncfusion's ItemModel.disabled only adds .e-overlay on the wrapper and leaves aria-disabled="false"
       on the button, so enabled primary styles must exclude .e-overlay as well. */
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #addNewReturn:not([aria-disabled='true']),
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #bulkEditSave:not([aria-disabled='true']) {
        background-color: var(--colorBrandBackground) !important;
        color: var(--colorNeutralForegroundOnBrand) !important;
        border-color: transparent !important;
    }

    .e-toolbar .e-toolbar-item:not(.e-overlay) > #addNewReturn:not([aria-disabled='true']) .e-btn-icon,
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #addNewReturn:not([aria-disabled='true']) .e-tbar-btn-text,
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #bulkEditSave:not([aria-disabled='true']) .e-btn-icon,
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #bulkEditSave:not([aria-disabled='true']) .e-tbar-btn-text {
        color: var(--colorNeutralForegroundOnBrand) !important;
    }

    .e-toolbar .e-toolbar-item:not(.e-overlay) > #addNewReturn:not([aria-disabled='true']):hover,
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #addNewReturn:not([aria-disabled='true']):focus:not(:focus-visible),
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #bulkEditSave:not([aria-disabled='true']):hover,
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #bulkEditSave:not([aria-disabled='true']):focus:not(:focus-visible) {
        background-color: var(--colorBrandBackgroundHover) !important;
        border-color: transparent !important;
    }

    /* Fluent primary focus-visible: StrokeFocus2 outer ring + OnBrand inner inset so the ring reads on brand fill. */
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #addNewReturn:not([aria-disabled='true']):focus-visible,
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #bulkEditSave:not([aria-disabled='true']):focus-visible {
        background-color: var(--colorBrandBackgroundHover) !important;
        border-color: var(--colorStrokeFocus2) !important;
        outline: var(--strokeWidthThick) solid var(--colorTransparentStroke) !important;
        box-shadow: var(--shadow2), 0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,
            0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset !important;
        z-index: 1;
    }

    .e-toolbar .e-toolbar-item:not(.e-overlay) > #addNewReturn:not([aria-disabled='true']):hover:active,
    .e-toolbar .e-toolbar-item:not(.e-overlay) > #bulkEditSave:not([aria-disabled='true']):hover:active {
        background-color: var(--colorBrandBackgroundPressed) !important;
    }

    /* Fluent appearance="primary" disabled: NeutralBackgroundDisabled fill + NeutralForegroundDisabled
       text, transparent border (not NeutralStrokeDisabled -- that is the outline/secondary disabled look).
       See https://storybooks.fluentui.dev/react/?path=/docs/components-button-button--docs#disabled-2
       Match both aria-disabled and Syncfusion's .e-overlay wrapper (ItemModel.disabled). Cursor /
       pointer-events for the overlay case are handled on .e-toolbar-item.e-overlay above. */
    .e-toolbar .e-toolbar-item.e-overlay > #addNewReturn,
    .e-toolbar .e-toolbar-item.e-overlay > #bulkEditSave,
    #addNewReturn[aria-disabled='true'],
    #bulkEditSave[aria-disabled='true'] {
        background-color: var(--colorNeutralBackgroundDisabled) !important;
        color: var(--colorNeutralForegroundDisabled) !important;
        border-color: transparent !important;
        cursor: not-allowed !important;
    }

    .e-toolbar .e-toolbar-item.e-overlay > #addNewReturn .e-btn-icon,
    .e-toolbar .e-toolbar-item.e-overlay > #addNewReturn .e-tbar-btn-text,
    .e-toolbar .e-toolbar-item.e-overlay > #bulkEditSave .e-btn-icon,
    .e-toolbar .e-toolbar-item.e-overlay > #bulkEditSave .e-tbar-btn-text,
    #addNewReturn[aria-disabled='true'] .e-btn-icon,
    #addNewReturn[aria-disabled='true'] .e-tbar-btn-text,
    #bulkEditSave[aria-disabled='true'] .e-btn-icon,
    #bulkEditSave[aria-disabled='true'] .e-tbar-btn-text {
        color: inherit !important;
    }

    /* Keep primary disabled surfaces stable on hover/focus -- Fluent does not restyle them. */
    .e-toolbar .e-toolbar-item.e-overlay > #addNewReturn:hover,
    .e-toolbar .e-toolbar-item.e-overlay > #addNewReturn:focus,
    .e-toolbar .e-toolbar-item.e-overlay > #addNewReturn:hover:active,
    .e-toolbar .e-toolbar-item.e-overlay > #bulkEditSave:hover,
    .e-toolbar .e-toolbar-item.e-overlay > #bulkEditSave:focus,
    .e-toolbar .e-toolbar-item.e-overlay > #bulkEditSave:hover:active,
    #addNewReturn[aria-disabled='true']:hover,
    #addNewReturn[aria-disabled='true']:focus,
    #addNewReturn[aria-disabled='true']:hover:active,
    #bulkEditSave[aria-disabled='true']:hover,
    #bulkEditSave[aria-disabled='true']:focus,
    #bulkEditSave[aria-disabled='true']:hover:active {
        background-color: var(--colorNeutralBackgroundDisabled) !important;
        color: var(--colorNeutralForegroundDisabled) !important;
        border-color: transparent !important;
        cursor: not-allowed !important;
    }

    /* Toolbar Search: same Fluent Input / SearchBox medium chrome as Column Chooser search
       (.e-cc-searchdiv) and FilterSearchBar. Syncfusion owns the markup
       (.e-search-wrapper > .e-input-group.e-search); there is no prop to swap it for a Fluent control. */
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        align-items: center !important;
    }

    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search {
        display: flex !important;
        align-items: center !important;
        gap: var(--spacingHorizontalXXS);
        box-sizing: border-box;
        position: relative !important;
        width: 230px !important;
        min-height: 32px !important;
        height: 32px !important;
        margin: 0 !important;
        background-color: var(--colorNeutralBackground1) !important;
        border: 1px solid var(--colorNeutralStroke1) !important;
        border-bottom-color: var(--colorNeutralStrokeAccessible) !important;
        border-radius: var(--borderRadiusMedium) !important;
        padding: 0 var(--spacingHorizontalS) !important;
        line-height: var(--lineHeightBase300) !important;
        overflow: visible !important;
        outline: none !important;
        box-shadow: none !important;
    }

    /* Hide Syncfusion's underline chrome; Fluent Input focus uses our ::after below. */
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search::before {
        display: none !important;
        content: none !important;
        width: 0 !important;
        background: none !important;
    }

    /* Fluent Input / SearchBox medium focus underline (scaleX brand stroke on focus-within). */
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search::after {
        box-sizing: border-box !important;
        content: '' !important;
        position: absolute !important;
        left: -1px !important;
        bottom: -1px !important;
        right: -1px !important;
        width: auto !important;
        height: max(2px, var(--borderRadiusMedium)) !important;
        border: none !important;
        border-bottom-left-radius: var(--borderRadiusMedium);
        border-bottom-right-radius: var(--borderRadiusMedium);
        border-bottom: 2px solid var(--colorCompoundBrandStroke) !important;
        clip-path: inset(calc(100% - 2px) 0 0 0);
        transform: scaleX(0);
        transition-property: transform;
        transition-duration: var(--durationUltraFast);
        transition-delay: var(--curveAccelerateMid);
        background: none !important;
        pointer-events: none;
    }

    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search:hover {
        border-color: var(--colorNeutralStroke1Hover) !important;
        border-bottom-color: var(--colorNeutralStrokeAccessibleHover) !important;
        box-shadow: none !important;
    }

    /* Kill Syncfusion fluent2's primary (blue) focus border -- Fluent only uses the ::after underline. */
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search:active,
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search:focus-within,
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search.e-input-focus {
        outline: none !important;
        box-shadow: none !important;
        border: 1px solid var(--colorNeutralStroke1Pressed) !important;
        border-bottom-color: var(--colorNeutralStrokeAccessiblePressed) !important;
    }

    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search:focus-within::after,
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search.e-input-focus::after {
        transform: scaleX(1);
        width: auto !important;
        background: none !important;
        transition-property: transform;
        transition-duration: var(--durationNormal);
        transition-delay: var(--curveDecelerateMid);
    }

    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search:focus-within:active::after {
        border-bottom-color: var(--colorCompoundBrandStrokePressed);
    }

    @media screen and (prefers-reduced-motion: reduce) {
        &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search::after,
        &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search:focus-within::after,
        &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search.e-input-focus::after {
            transition-duration: 0.01ms;
            transition-delay: 0.01ms;
        }
    }

    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search .e-input {
        flex: 1;
        min-width: 0;
        width: auto !important;
        height: auto !important;
        border: none !important;
        background: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
        text-indent: 0 !important;
        color: var(--colorNeutralForeground1);
        font-family: var(--fontFamilyBase);
        font-size: var(--fontSizeBase300);
        font-weight: var(--fontWeightRegular);
        line-height: var(--lineHeightBase300);
        opacity: 1 !important;
        outline: none !important;
        box-shadow: none !important;
    }

    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search .e-input::placeholder {
        color: var(--colorNeutralForeground4);
        opacity: 1;
    }

    /* Syncfusion's input-group-icon theme fixes this span at 30x30 via min-width/min-height -- same fix as
       Column Chooser search so the glyph doesn't sit in a wider dead box. Sized to match FilterSearchBar. */
    &.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-input-group.e-search .e-input-group-icon {
        float: none !important;
        padding: 0 !important;
        margin: 0 !important;
        width: 24px !important;
        height: 24px !important;
        min-width: 24px !important;
        min-height: 24px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        color: var(--colorNeutralForeground3);
        font-size: 14px !important;
        background: none !important;
        border: none !important;
        box-shadow: none !important;
    }
`;
